import React from 'react';
import PropTypes from 'prop-types';
import PageHeader from 'components/common/PageHeader';
import Accordion from 'react-bootstrap/Accordion';

const ProcessFollow = ({ dadosFollow }) => {
  return (
    <>
      <PageHeader titleTag="h5" title={`Acompanhamento`}>
        {/* <Accordion title="Tracking" flush>
          <Accordion.Item eventKey="0">
            <Accordion.Header>Acompanhamento</Accordion.Header>
            <Accordion.Body> */}
              <div className="row align-items-start mt-2">
                {dadosFollow.map(row => {
                  return (
                    <>
                      <div className="row align-items-start mt-2">
                        <div
                          className="col d-inline-flex"
                          style={{ whiteSpace: 'pre-line' }}
                        >
                          <span
                            style={{
                              fontSize: '.7rem',
                              whiteSpace: 'nowrap',
                              fontWeight: 'bold'
                            }}
                          >
                            {row.data_proinf}
                            &nbsp; - &nbsp;
                          </span>
                          <h6 style={{ fontWeight: 'normal' }}>
                            {row.desc_proinf}
                          </h6>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            {/* </Accordion.Body>
          </Accordion.Item>
        </Accordion> */}
      </PageHeader>
      {/* <PageHeader title={`ACOMPANHAMENTO`} titleTag="h5" >
        {' '}
        <div class="">
          {dadosFollow.map(row => {
            return (
              <>
                <div class="row align-items-start mt-1">
                  <div class="col d-inline-flex">
                    <h6>{row.data_proinf}
                    &nbsp; - &nbsp;
                    {row.desc_proinf}
                    </h6>
                  </div>
                  
                </div>
              </>
            );
          })}
        </div>
      </PageHeader> */}
    </>
  );
};

ProcessFollow.propTypes = {
  dadosFollow: PropTypes.arrayOf(
    PropTypes.shape({
      IdAcompanhamento: PropTypes.number.isRequired,
      data_proinf: PropTypes.string.isRequired,
      desc_proinf: PropTypes.string.isRequired
    })
  ).isRequired
};

export default ProcessFollow;
